import React, { Component } from "react";
import PropTypes from "prop-types";

class BooleanStringCellRender extends Component {

  render() {
    return (
      <input
        type="checkbox"
        readOnly={true}
        checked={this.props.value == "A"}
      />
    );
  }
}

BooleanStringCellRender.propTypes = {
  value: PropTypes.any,
};

export default BooleanStringCellRender;
